<template>
  <div>
    <div class="fixed_bottom_basket plr"
         v-if="$store.getters.selectedProducts.length > 0 && $route.name === 'receipt' && $store.getters.enableOrder && (
                 this.$store.getters.contactlessMode || $store.getters.outletSettings.delivery_type === 4 || this.$store.getters.canPerformOrder
             )">

      <template
        v-if="$route.name === 'receipt' && $store.getters.totalOnlyProductsNoDiscount < $store.getters.outletSettings.order_from">
        <a class="fbb_btn fbb_btn_disable" >
          {{buttonText}}<i :class="{ 'ios-font': $store.getters.checkIos }" v-html="$options.filters.toCurrency($store.getters.totalPrice)"></i>
        </a>
      </template>
      <a @click="next()" class="fbb_btn" v-else>
        {{buttonText}}<i :class="{ 'ios-font': $store.getters.checkIos }" v-html="$options.filters.toCurrency($store.getters.totalPrice)"></i>
      </a>

    </div>
  </div>

</template>

<script>
  import BasketCount from '@/components/Default/Basket/Count.vue'
  import {SET_MODAL} from '@/store/mutations.type'
  import {MAKE_ORDER} from '@/store/actions.type'

  export default {
    name: 'Basket',
    components: {
      BasketCount
    },
    data() {
      return {
        basketNextRoute: 'receipt'
      }
    },
    watch: {
      '$route': {
        handler: function (route) {
          let time = 100

          if (route.name === 'home' && this.basketNextRoute !== 'receipt') {
            setTimeout(() => {
              this.basketNextRoute = 'receipt'
            }, time)
          }
          if (route.name === 'receipt' && this.basketNextRoute !== 'form') {
            setTimeout(() => {
              this.basketNextRoute = 'form'
            }, time)
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {

      next() {
        if (this.basketNextRoute === 'form' && this.$store.getters.upsell.length > 0) {
          return this.$store.commit(SET_MODAL, {modal: 'upsell', status: true})
        }
        if (
          this.basketNextRoute === 'form' &&
          this.$store.getters.enableOrder &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          this.$store.dispatch(MAKE_ORDER, {})
        } else {
          return this.$router.push({name: this.basketNextRoute, params: {token: this.$store.getters.token}})
        }
      }

    },
    computed: {
      remainToOrder() {
        return this.$store.getters.outletSettings.order_from - this.$store.getters.totalPrice
      },
      buttonText() {
        let text = this.text('bottom_button_to_basket')
        if (this.$route.name === 'receipt' || this.$store.getters.totalPrice === 0 || this.$store.getters.enableOnlinePayment) {
          text = this.text('bottom_button_to_form_basket')
        }
        if (
          this.$route.name === 'receipt' &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          text = this.text('screen_form_cashback_make_order')
        }
        return text
      }
    }
  }
</script>

<style>
</style>
